import type { SubItem } from "@/features/cart/types";
import type { ConfigurationItemAddon } from "../types/configuration-item-addon.type";

// Bridge between the view-local addon model ({ addonId, date, quantity }) and
// the cart sub-item contract sent to / returned by PUT /cart/{id} (MPL-3694).

// Outgoing: flatten the selected addons into the `subItems` payload.
export const addonsToSubItems = (addons: ConfigurationItemAddon[]): SubItem[] =>
  addons.map(({ addonId, date, quantity }) => ({
    type: "addon",
    id: addonId,
    date,
    quantity,
  }));

// Incoming: seed the addon store from an item's persisted sub-items, keeping
// only the addon kind (the only one today, but the discriminator is explicit).
export const subItemsToAddons = (
  subItems: SubItem[] = [],
): ConfigurationItemAddon[] =>
  subItems
    .filter((subItem) => subItem.type === "addon")
    .map(({ id, date, quantity }) => ({ addonId: id, date, quantity }));
